import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { createTabBarNavButton } from 'src/navigation/components/TabBarNavButton';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const renderExamPreparationTabRoutes = ({ translate, }) => {
    return (React.createElement(RootTab.Group, null,
        React.createElement(RootTab.Screen, { name: "EP_Home", options: {
                tabBarLabel: translate('Exams'),
                tabBarIcon: props => React.createElement(FeatherIcon, { name: "edit-3", ...props }),
                tabBarButton: createTabBarNavButton({ screen: 'EP_Home', params: {} }),
            }, component: Home })));
};
